module.exports = __webpack_public_path__ + "6309eb34eef2ba2be32e8633dee8c287.png";